/**
 * @generated SignedSource<<7acccd7d7c34ab5c708abf21d9c87ede>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type WorkspaceMembersPageRemoveInviteeMutation$variables = {
  inviteId: string;
};
export type WorkspaceMembersPageRemoveInviteeMutation$data = {
  readonly removeWorkspaceInvitee: boolean;
};
export type WorkspaceMembersPageRemoveInviteeMutation = {
  response: WorkspaceMembersPageRemoveInviteeMutation$data;
  variables: WorkspaceMembersPageRemoveInviteeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "inviteId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "inviteId",
        "variableName": "inviteId"
      }
    ],
    "kind": "ScalarField",
    "name": "removeWorkspaceInvitee",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceMembersPageRemoveInviteeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceMembersPageRemoveInviteeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "48b1d18d35ac65e3e3cdde54644aebc6",
    "id": null,
    "metadata": {},
    "name": "WorkspaceMembersPageRemoveInviteeMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceMembersPageRemoveInviteeMutation(\n  $inviteId: ID!\n) {\n  removeWorkspaceInvitee(inviteId: $inviteId)\n}\n"
  }
};
})();

(node as any).hash = "aef8141401f886c884150d8894a5d706";

export default node;
